import { combineReducers } from '@reduxjs/toolkit'
import { surveyQuestionsReducer, resetSurveyQuestions } from './survey-questions-slice'
import { surveySubmitReducer, resetSurveySubmit } from './survey-submit-slice'
import { surveySkipReducer, resetSurveySkip } from './survey-skip-slice'
import { surveyResultReducer, resetSurveyResult } from './survey-result-slice'
import type { AppDispatch } from '@/app/store'

export const surveyReducer = combineReducers({
  surveyQuestions: surveyQuestionsReducer,
  surveySubmit: surveySubmitReducer,
  surveySkip: surveySkipReducer,
  surveyResult: surveyResultReducer,
})

/**
 * 複数のアンケート関連のstateをリセットする
 */
export const resetAllSurveyState = () => {
  return (dispatch: AppDispatch) => {
    dispatch(resetSurveyQuestions())
    dispatch(resetSurveySubmit())
    dispatch(resetSurveyResult())
    dispatch(resetSurveySkip())
  }
}

/**
 * 個別のリセットアクションをexport
 */
export { resetSurveyQuestions, resetSurveySubmit, resetSurveySkip, resetSurveyResult }
